/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
/* eslint-disable @atlaskit/ui-styling-standard/no-global-styles */
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */

import React from 'react';

import { jsx } from '@compiled/react';

const DRAW_KEYFRAMES_NAME = 'twgHeroTypographyScribbleDraw';

const SCRIBBLE = {
	width: 178,
	height: 165,
	pathD:
		'M74.527 48.552C63.4 26.3-41.34 93.69 28.125 104.907c51.138 8.257 94.683-83.471 34.285-74.57-24.655 3.634-31.028 46.09-13.587 60.61 23.538 19.597 107.363.256 79.404-38.34-36.562-50.472-129.125 28.31-86.2 63.41 25.934 21.206 96.114-24.685 102.756-51.73 6.277-25.554-30.165-60.643-55.949-58.535-52.354 4.282-70.047 107.216-18.157 123.721 37.428 11.906 102.665-27.813 96.284-71.15C153.663-32 28.698 55.457 56.995 133.883c9.78 27.107 95.494-48.722 100.203-71.573C164.687 25.968 121.5-.802 89.128 5.395c-49.75 9.522-88.044 106.312-47.669 142.503 40.61 36.402 139.385-41.985 105.887-91.117-47.568-69.768-113.202 40.331-91.767 80.13 25.221 46.83 120.094 14.296 116.911-26.592',
	strokeWidth: 9,
	strokeLinecap: 'round',
} as const;

export type EaseControlPoints = [number, number, number, number];

const DEFAULT_EASE: EaseControlPoints = [0.55, 0.055, 0.675, 0.19];

function formatCubicBezier([x1, y1, x2, y2]: EaseControlPoints) {
	return `cubic-bezier(${x1}, ${y1}, ${x2}, ${y2})`;
}

export type ScribbleProps = {
	durationMs?: number;
	ease?: EaseControlPoints;
	color?: string;
	lineWidth?: number;
	blurPx?: number;
	reducedMotion?: boolean;
};

export function Scribble({
	durationMs = 1000,
	ease = DEFAULT_EASE,
	color = '#FFC716',
	lineWidth = SCRIBBLE.strokeWidth,
	blurPx = 0,
	reducedMotion = false,
}: ScribbleProps): JSX.Element {
	return (
		<>
			<style>{`
				@keyframes ${DRAW_KEYFRAMES_NAME} {
					from { stroke-dashoffset: 1; }
					to { stroke-dashoffset: 0; }
				}
			`}</style>
			<svg
				viewBox={`0 0 ${SCRIBBLE.width} ${SCRIBBLE.height}`}
				fill="none"
				overflow="visible"
				aria-hidden
				style={{ width: '100%', height: '100%' }}
			>
				<path
					d={SCRIBBLE.pathD}
					pathLength={1}
					stroke={color}
					strokeLinecap={SCRIBBLE.strokeLinecap}
					strokeWidth={lineWidth}
					style={{
						filter: blurPx > 0 ? `blur(${blurPx}px)` : undefined,
						strokeDasharray: 1,
						strokeDashoffset: reducedMotion ? 0 : 1,
						animation: `${DRAW_KEYFRAMES_NAME} ${reducedMotion ? 0 : Math.max(0, durationMs)}ms ${formatCubicBezier(ease)} forwards`,
					}}
				/>
			</svg>
		</>
	);
}
